import styled from 'styled-components';
import { CloseOutlined } from '@ant-design/icons';

const StyledCloseOutlined = styled(CloseOutlined)`
    fontsize: 16px;
    padding-bottom: 5px;
`;

export default StyledCloseOutlined;
